/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext} from 'react';
import {CurrencyContext} from "../../../contexts/AppContext";
import {ConvertedDeviseWithMoneySign} from "../../../utils/CurrencyConvertFunction"
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { colors } from '../../../styles/defaultColors';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { Stack } from '@mui/material';
import { IUserService } from '../../../Services/userServecesServices';

const useStyles = makeStyles(() => createStyles({
    seletedItem:{
        backgroundColor: 'rgb(0 0 0 / 4%)',
        padding: 16,
        marginTop: 16
    },
    footer:{
        display: 'flex',
        justifyContent: 'space-betwee',
        alignItem: 'center'
    },
    bolder: {
        fontWeight: 'bolder',
    },
    title: {
        fontSize: 18,
        fontFamily: "Josefin Sans",
        // marginTop: 40,
    },
    body:{
        color: colors.darkerGrey
    },
    price:{
        fontSize: 16,
        color: "#EA7606",
    },
    '@global': {
        '.MuiButton-root': {
            textTransform: 'none',
        },
        '.text_body': {
            lineHeight: '20px',
            fontWeight: 300,
            fontSize: 12
        }
    }
}))

export const SelectedServiceItem = ({userService, handleRemoveItem}:{userService:IUserService, handleRemoveItem:(val: string)=>void}) => {
    const currencyContext = useContext(CurrencyContext);
    const {currency,} = currencyContext;
    const [priceConverted, setPriceConverted] = React.useState<number>(0);
    const classes= useStyles();
    
    React.useEffect(()=>{        
        ConvertedDeviseWithMoneySign('XAF', currency, Number(userService.price)).then((value: any): any => setPriceConverted(value)).catch(error => console.log(error))
    }, []);
    
    React.useEffect(()=>{        
        ConvertedDeviseWithMoneySign('XAF', currency, Number(userService.price)).then((value: any): any => setPriceConverted(value)).catch(error => console.log(error))
    }, [currency])

    const handleClick=()=>{
        handleRemoveItem(userService._id);
    }
    return (
        <div className={classes.seletedItem}>
            <Grid container spacing={1}>     
                <Grid item md={12}>
                    <Typography className={classes.title}>
                        {userService.name}
                    </Typography>
                    <p className={classes.body}>
                        {userService.description}
                    </p>
                </Grid>            

                <Grid item md={12}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={3}>
                    <div className={classes.price}>{priceConverted}</div>                     
                    <IconButton onClick={handleClick}  component="span">
                        <CloseIcon />
                    </IconButton>
                    </Stack>
                </Grid>   
            </Grid>
        </div>
    )
}
